

const mainColor = '#1376e3'
const barColor = '#1aa95d'

export const GlobalStyle = {
  colors: {
    main: mainColor,
    bar: barColor,
    cardBg:'#dfeaf8',
    // attdncGood:'#90caf9',
    attdncGood:'#e3f2fd',
    attdncBad:'#fffde7',
    // attdncBad:'#fff59d',
  }
}

export default GlobalStyle
